import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: false,
  styleUrl: 'paf-autocomplete-item.scss',
  tag: 'paf-autocomplete-item',
})

export class PafAutocompleteItem implements ComponentInterface {

  /**
   * Id must be provided in order to properly anounce the aria-activedescendant
   * inside the input field
   */
 @Prop() public itemId!: string;

  /**
   * Text to show as content of the autocomplete item
   */
  @Prop() public text!: string;

  /**
   * Mark the item as selected, which will change it's appearance and
   * the according aria attributes
   */
  @Prop() public selected?: boolean;

  /**
   * The aria-posinset attribute for the list element
   */
  @Prop() public ariaPosinset?: number;

  /**
   * The aira-setsize attribute for the list element
   */
  @Prop() public ariaSetsize?: number;

  private _setAriaAttributes(): any {

    const attrs = {};

    if (this.ariaPosinset) {
      attrs['aria-posinset'] = this.ariaPosinset;
    }

    if (this.ariaSetsize) {
      attrs['aria-setsize'] = this.ariaSetsize;
    }

    return attrs;
  }

  public render(): HTMLDivElement {
    return (
      <li
        class={{
          'autocomplete-item': true,
          'autocomplete-item--selected': this.selected,
        }}
        role='option'
        aria-selected={this.selected}
        id={this.itemId}
        {...this._setAriaAttributes()}
        tabindex='-1'
        data-testid='item'
      >
        {this.text}
      </li>
    );
  }
}
